const AD_LINK_WANTED = "https://www.wanted.co.kr/";

export default AD_LINK_WANTED;
